(() => {
  const initHeader = (root) => {
    if (!root || root.dataset.morgrieReady === "true") return;
    root.dataset.morgrieReady = "true";

    const triggers = [...root.querySelectorAll("[data-nav-trigger]")];
    const panels = [...root.querySelectorAll("[data-nav-panel]")];
    const mobileToggle = root.querySelector("[data-mobile-menu-toggle]");
    const mobileNavigation = root.querySelector("[data-mobile-navigation]");

    const closeDesktopMenus = (exceptId = "") => {
      triggers.forEach((trigger) => {
        const panelId = trigger.getAttribute("aria-controls");
        if (panelId === exceptId) return;
        trigger.setAttribute("aria-expanded", "false");
        trigger.closest("[data-nav-trigger-wrap]")?.classList.remove("active");
      });
      panels.forEach((panel) => {
        if (panel.id !== exceptId) panel.hidden = true;
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const panelId = trigger.getAttribute("aria-controls");
        const panel = root.querySelector(`#${CSS.escape(panelId)}`);
        if (!panel) return;

        const willOpen = trigger.getAttribute("aria-expanded") !== "true";
        closeDesktopMenus(willOpen ? panelId : "");
        trigger.setAttribute("aria-expanded", String(willOpen));
        trigger
          .closest("[data-nav-trigger-wrap]")
          ?.classList.toggle("active", willOpen);
        panel.hidden = !willOpen;
      });
    });

    mobileToggle?.addEventListener("click", () => {
      if (!mobileNavigation) return;
      const willOpen = mobileToggle.getAttribute("aria-expanded") !== "true";
      closeDesktopMenus();
      mobileToggle.setAttribute("aria-expanded", String(willOpen));
      mobileToggle.textContent = willOpen ? "close" : "menu";
      mobileNavigation.hidden = !willOpen;
      document.body.classList.toggle("mobile-menu-open", willOpen);
    });

    root.querySelectorAll(".openCartDrawer").forEach((cartLink) => {
      cartLink.addEventListener("click", () => {
        closeDesktopMenus();
        if (mobileNavigation && !mobileNavigation.hidden) {
          mobileNavigation.hidden = true;
          mobileToggle?.setAttribute("aria-expanded", "false");
          if (mobileToggle) mobileToggle.textContent = "menu";
          document.body.classList.remove("mobile-menu-open");
        }
      });
    });

    root.addEventListener("click", (event) => {
      if (event.target === root) closeDesktopMenus();
    });

    document.addEventListener("click", (event) => {
      if (!root.contains(event.target)) closeDesktopMenus();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      closeDesktopMenus();
      if (mobileNavigation && !mobileNavigation.hidden) {
        mobileNavigation.hidden = true;
        mobileToggle?.setAttribute("aria-expanded", "false");
        if (mobileToggle) mobileToggle.textContent = "menu";
        document.body.classList.remove("mobile-menu-open");
        mobileToggle?.focus();
      }
    });
  };

  const initPageControls = (scope = document) => {
    scope.querySelectorAll(".color-selector").forEach((selector) => {
      if (selector.dataset.colorSwitchReady === "true") return;
      selector.dataset.colorSwitchReady = "true";

      const showcase = selector.closest(".product-showcase");
      const image = showcase?.querySelector("[data-product-color-image]");
      let switchRequestId = 0;

      selector.querySelectorAll(".color-option").forEach((option) => {
        option.addEventListener("click", () => {
          selector.querySelectorAll(".color-option").forEach((item) => {
            item.classList.remove("active");
            item.setAttribute("aria-pressed", "false");
          });
          option.classList.add("active");
          option.setAttribute("aria-pressed", "true");

          const nextSource = option.dataset.colorImage;
          const requestId = ++switchRequestId;
          if (!image || !nextSource) return;

          const resolvedSource = new URL(nextSource, document.baseURI).href;
          if (image.src === resolvedSource || image.currentSrc === resolvedSource) {
            image.classList.remove("is-switching");
            return;
          }

          const preload = new Image();
          image.classList.add("is-switching");
          preload.onload = () => {
            if (requestId !== switchRequestId) return;
            image.src = resolvedSource;
            image.alt = option.dataset.colorAlt || image.alt;
            image.classList.remove("is-switching");
          };
          preload.onerror = () => {
            if (requestId === switchRequestId) {
              image.classList.remove("is-switching");
            }
          };
          preload.src = resolvedSource;
        });
      });
    });

    scope.querySelectorAll("[data-morgrie-sort]").forEach((select) => {
      select.addEventListener("change", () => {
        const url = new URL(window.location.href);
        url.searchParams.set("sort_by", select.value);
        window.location.assign(url.toString());
      });
    });

    scope.querySelectorAll(".morgrie-collection").forEach((collection) => {
      const sidebar = collection.querySelector("[data-filter-sidebar]");
      const openButton = collection.querySelector("[data-filter-open]");
      const closeButton = collection.querySelector("[data-filter-close]");

      const setOpen = (open) => {
        sidebar?.classList.toggle("is-open", open);
        document.body.classList.toggle("keycap-filter-open", open);
      };

      openButton?.addEventListener("click", () => setOpen(true));
      closeButton?.addEventListener("click", () => setOpen(false));
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll("[data-morgrie-header]").forEach(initHeader);
    initPageControls(scope);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) =>
    init(event.target),
  );
})();
